const translationsEn = {
  mercure: {
    rates: {
      welcomeMessage: "Welcome to Mercure<br>{hotelName}",
      roomRatesTitle: "services rates",
      dayRate: "Day rate"
    }
  },
  barriere: {
    change: {
      title: "exchange rates",
      updateDate: "Update date"
    }
  },
  ibis: {
    rates: {
      additionalServices: "Additional services",
      additionalServicesSubtitle: "consult reception"
    }
  },
  novotel: {
    rates: {
      roomRatesTitle: "services rates",
      dayRate: "Day rate"
    }
  },
  tribe: {
    rates: {
      roomRatesTitle: "services rates",
      memberCard: "member card",
      dayRate: "Day rate"
    }
  }
};

export default translationsEn;



// WEBPACK FOOTER //
// ./src/tools/i18n/en.js